// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let UnifiedProfileSettingsUI = require("./UnifiedProfileSettingsUI.bs.js");
let ProfilePageAddressInformationForm = require("./ProfilePageAddressInformationForm.bs.js");
let UnifiedYourProfilePersonalInformationForm = require("./UnifiedYourProfilePersonalInformationForm.bs.js");
let UnifiedYourProfileProfessionalInformationForm = require("./UnifiedYourProfileProfessionalInformationForm.bs.js");
let UnifiedYourProfileBasicInfoSettingsQuery_graphql = require("../../__generated__/UnifiedYourProfileBasicInfoSettingsQuery_graphql.bs.js");

let convertVariables = UnifiedYourProfileBasicInfoSettingsQuery_graphql.Internal.convertVariables;

let convertResponse = UnifiedYourProfileBasicInfoSettingsQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = UnifiedYourProfileBasicInfoSettingsQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, UnifiedYourProfileBasicInfoSettingsQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, UnifiedYourProfileBasicInfoSettingsQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(UnifiedYourProfileBasicInfoSettingsQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(UnifiedYourProfileBasicInfoSettingsQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(UnifiedYourProfileBasicInfoSettingsQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(UnifiedYourProfileBasicInfoSettingsQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function UnifiedYourProfileBasicInfoSettings(props) {
  let match = use(undefined, undefined, undefined, undefined);
  let agent = match.currentlyLoggedInAgent;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(UnifiedProfileSettingsUI.SubpageHeader.make, {
        title: "Personal Information",
        rootName: "Your Profile",
        rootUrl: "/account/profile",
        url: "/account/profile/basic_info"
      }),
      JsxRuntime.jsx(UnifiedYourProfilePersonalInformationForm.make, {
        agent: agent.fragmentRefs
      }),
      JsxRuntime.jsx(ProfilePageAddressInformationForm.make, {
        agent: agent.fragmentRefs
      }),
      JsxRuntime.jsx(UnifiedYourProfileProfessionalInformationForm.make, {
        agent: agent.fragmentRefs
      })
    ],
    className: "space-y-8 rounded bg-white p-6 shadow-sm"
  });
}

let make = UnifiedYourProfileBasicInfoSettings;

exports.Query = Query;
exports.make = make;
/* use Not a pure module */
